module.exports = __webpack_public_path__ + "static/media/logo_full.cd94e8b6.png";